import MenuTypes from './menu.types';

export const toggleMenu = show => ({
    type: MenuTypes.TOGGLE_MENU,
    payload: show
});

export default toggleMenu;